import ApplicationController from './application_controller'
import * as XLSX from 'xlsx/xlsx.mjs'

export default class extends ApplicationController {
  export(event) {
    const { id, type = 'xlsx', prodType = 'export' } = event?.params || {}

    const table = id
      ? document.getElementById(id)
      : this.element.querySelector('table')

    if (!table) return

    const wb = XLSX.utils.table_to_book(table)
    const fname = `${prodType}_produksjonsdata.${type}`
    XLSX.writeFile(wb, fname)
  }
}
